import { getDepartmentItem } from "./components";
import { getJobsData } from "./getJobsData";
import { getOpenPositions } from "./getOpenPositions";
import { hideLoadingIndicator, showLoadingIndicator } from "./loading";

export function getDepartments() {
	const departmentsList = document.getElementById("openPositionsDepartments");

	if (!departmentsList) {
		return;
	}

	showLoadingIndicator("openPositionsDepartments");

	const successHandler = (data) => {
		departmentsList.appendChild(
			getDepartmentItem({
				name: "All departments",
				selected: "true",
			}),
		);

		data.forEach((department) => {
			const listItem = getDepartmentItem({
				id: department.id,
				name: department.name,
			});
			departmentsList.appendChild(listItem);
		});

		hideLoadingIndicator("openPositionsDepartments");
	};

	getJobsData("/departments", {}, successHandler, () => {});
}

export function onDepartmentItemClick(button) {
	const list = button.parentElement.parentElement;

	list.querySelectorAll(".list-item").forEach((button) => {
		button.setAttribute("aria-selected", "false");
		button.classList.remove("active");
	});

	button.setAttribute("aria-selected", "true");
	button.classList.add("active");
	getOpenPositions();
}
